module.exports = __webpack_public_path__ + "img/medal_ouro.e3b1d249.svg";